import { forEach, noop } from 'lodash'
import React, { useEffect } from 'react'
import { Col, Row } from 'react-bootstrap'

import Button from '../../../Button'
import {
  IField,
  IFilter,
  IUi,
  TApplyFilterVal,
  TGetFormApi,
  TSaveUi,
  TSetFilter,
} from '../../types'
import FilterRenderer from './FilterRenderer'

type TApplyLocalFilter = { reset?: boolean; onlyFts?: boolean } | boolean
interface FormProps extends TGetFormApi {
  filters: IFilter[]
  setFilter: TSetFilter
  apply: (val: boolean) => void
  applyColor: string
  isMobile: boolean
  setDetailFilterOpen: (val: IUi) => void
  applyLocalFilter: (val: TApplyLocalFilter) => void
  useLocalStateFiltering: boolean
  initialFilters: IFilter
  saveUi: TSaveUi
  initialValues?: any
  setFilterMode: () => void
  filterMode: string
  setIncluded: boolean
}

const Form = (props: FormProps): React.ReactElement => {
  const {
    form,
    getFormApi = noop,
    filters,
    setFilter,
    apply,
    applyColor,
    isMobile,
    setDetailFilterOpen,
    applyLocalFilter,
    useLocalStateFiltering,
    initialFilters,
    saveUi,
    setFilterMode,
    filterMode,
    setIncluded,
  } = props

  useEffect((): void => {
    if (form && getFormApi) {
      getFormApi(form)
      const values = { ...props.initialValues }

      form.batch(() => {
        forEach(values, (value, key) => form.change(key, value))
      })
    }
  }, [])

  const reset = (): void => {
    if (form) {
      form.reset()
    }

    if (useLocalStateFiltering) {
      applyLocalFilter({ reset: true, onlyFts: false })
    } else {
      if (apply) {
        apply(true)
      }

      if (form) {
        form.batch(() => {
          forEach(initialFilters, (filter: IField) =>
            form.change(`${filter.field}`, `${filter.value}`),
          )
        })
      }
    }
  }

  const handleKeyDown = (event: React.KeyboardEvent): void => {
    if (event.key === 'Enter') {
      if (useLocalStateFiltering) {
        applyLocalFilter({ reset: false, onlyFts: false })
      } else {
        apply(false)
        saveUi({ isDetailOpen: false })
      }
    }
  }

  return (
    <React.Fragment>
      <Row className="mb-1">
        <Col className="text-right">
          <Button
            variant="light"
            size="sm"
            onClick={() => setDetailFilterOpen({ isDetailOpen: false })}
            id="infinity-table__close-filter"
          >
            <i className="fas fa-times" />
            &nbsp;
            {i18n.t('close_btn_filters', 'Schliessen')}
          </Button>
        </Col>
      </Row>
      <FilterRenderer
        filterMode="detail"
        filters={filters}
        handleKeyDown={handleKeyDown}
        setFilter={setFilter}
        isMobile={isMobile}
        form={form}
      />
      <Row>
        <Col className="d-flex justify-content-between mt-1">
          <Button
            variant="light"
            size="sm"
            onClick={reset}
            className="mr-2"
            id="infinity-table__detail-clear-filter"
          >
            <i className="fas fa-eraser" />
            &nbsp;
            {i18n.t('reset_search', 'Zurücksetzen')}
          </Button>
          <Button
            variant={applyColor}
            size="sm"
            onClick={() => apply(false)}
            id="infinity-table__submit-filter"
          >
            <i className="far fa-filter" />
            &nbsp; {i18n.t('apply_filter', 'Anwenden')}
          </Button>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default Form

export const stringifyValues = (values: unknown): any => {
  return values
}
